import { ChangeEvent} from 'react';
import Slider from '@material-ui/core/Slider';
import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import { ITableSettingsService } from '@base/features/table/interfaces';
import styles from '../styles/createTableMatchPoints.module.scss';
import { TableOptionsKey } from '@base/utils/constants';

export const CreateTableMatchPoints = (props: {
  value: number;
  handlerMatchPointsFee: (value: number) => void;
  disabled?: boolean;
}) => {
  const { value, handlerMatchPointsFee, disabled } = props;
  const tableSettingsRepository: ITableSettingsService = container.resolve('tableSettingsRepository');

  function handleSliderChange(event: ChangeEvent<Record<string, unknown>>, newValue: number | number[]) {
    if (typeof newValue === 'number') {
      //При 1 отключаем Crawford
      if (newValue === 1) {
        tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.MIN_POINTS, 0);
      }
      handlerMatchPointsFee(newValue);
    }
  }

  return (
    <section className={styles.match}>
      <div className={styles.title}>
        <div>{`${t('match')} ${t('points')}`}</div>
        <div>{value}</div>
      </div>
      <div className="slider-wrap">
        <Slider
          value={value}
          min={1}
          max={15}
          step={1}
          onChange={handleSliderChange}
          className={disabled ? 'disabled' : undefined}
        />
      </div>
    </section>
  );
};
